import { ScopeValues } from './types';

export const CONTACT_ACCOUNT_MANAGER = 'contact_account_manager';

const scopeValues: ScopeValues = {
  amazon: {
    userData: [
      {
        name: 'profile',
        required: false,
        value: 'profile'
      },
      {
        name: 'id',
        required: false,
        value: 'profile:user_id'
      },
      {
        name: 'postal-code',
        required: false,
        value: 'postal_code'
      }
    ],
    permissions: [],
    permissionDocLink: 'https://developer.amazon.com/docs/login-with-amazon/customer-profile.html',
    appIDDocLink: 'https://developer.amazon.com/docs/login-with-amazon/register-web.html'
  },
  apple: {
    userData: [
      {
        name: 'email',
        required: false,
        value: 'email'
      },
      {
        name: 'name',
        required: false,
        value: 'name'
      }
    ],
    permissions: [],
    permissionDocLink:
      'https://developer.apple.com/documentation/sign_in_with_apple/clientconfigi/3230955-scope',
    appIDDocLink: 'https://help.apple.com/developer-account/#/devde676e696'
  },
  babka: {
    userData: [
      {
        name: 'email',
        required: true,
        value: 'email'
      },
      {
        name: 'offline',
        required: true,
        value: 'offline'
      }
    ],
    permissions: [],
    permissionDocLink: '',
    appIDDocLink: CONTACT_ACCOUNT_MANAGER
  },
  baidu: {
    userData: [
      {
        name: 'profile',
        required: false,
        value: 'basic'
      }
    ],
    permissions: [
      {
        name: 'send-messages',
        required: false,
        value: 'super_msg'
      },
      {
        name: 'files',
        required: false,
        value: 'netdisk'
      }
    ],
    permissionDocLink: 'https://developer.baidu.com/wiki/index.php?title=docs/oauth',
    appIDDocLink:
      'https://openauth.baidu.com/doc/prepare.html#%E7%AC%AC%E4%BA%8C%E6%AD%A5%EF%BC%9A%E8%8E%B7%E5%8F%96%E5%BA%94%E7%94%A8ak%E5%8F%8Ask'
  },
  battlenet: {
    userData: [
      {
        name: 'openid',
        required: false,
        value: 'openid'
      },
      {
        name: 'profile-wow',
        required: false,
        value: 'wow.profile'
      },
      {
        name: 'profile-sc2',
        required: false,
        value: 'sc2.profile'
      },
      {
        name: 'profile-d3',
        required: false,
        value: 'd3.profile'
      }
    ],
    permissions: [],
    permissionDocLink: 'https://develop.battle.net/documentation/guides/using-oauth',
    appIDDocLink: 'https://develop.battle.net/documentation/guides/getting-started'
  },
  discord: {
    userData: [
      {
        name: 'profile',
        required: false,
        value: 'identify'
      },
      {
        name: 'email',
        required: false,
        value: 'email'
      },
      {
        name: 'connections',
        required: false,
        value: 'connections'
      },
      {
        name: 'guilds',
        required: false,
        value: 'guilds'
      }
    ],
    permissions: [
      {
        name: 'activities:read',
        required: false,
        value: 'activities.read'
      },
      {
        name: 'activities:write',
        required: false,
        value: 'activities.write'
      },
      {
        name: 'applications-builds:read',
        required: false,
        value: 'applications.builds.read'
      },
      {
        name: 'applications-builds:upload',
        required: false,
        value: 'applications.builds.upload'
      },
      {
        name: 'applications-commands',
        required: false,
        value: 'applications.commands'
      },
      {
        name: 'applications-commands:update',
        required: false,
        value: 'applications.commands.update'
      },
      {
        name: 'applications-entitlements',
        required: false,
        value: 'applications.entitlements'
      },
      {
        name: 'applications-store:update',
        required: false,
        value: 'applications.store.update'
      },
      {
        name: 'bot',
        required: false,
        value: 'bot'
      },
      {
        name: 'gdm:join',
        required: false,
        value: 'gdm.join'
      },
      {
        name: 'guilds:join',
        required: false,
        value: 'guilds.join'
      },
      {
        name: 'messages:read',
        required: false,
        value: 'messages.read'
      },
      {
        name: 'relationships:read',
        required: false,
        value: 'relationships.read'
      },
      {
        name: 'rpc',
        required: false,
        value: 'rpc'
      },
      {
        name: 'rpc-activities:write',
        required: false,
        value: 'rpc.activities.write'
      },
      {
        name: 'rpc-notifications:read',
        required: false,
        value: 'rpc.notifications.read'
      },
      {
        name: 'rpc-voice:read',
        required: false,
        value: 'rpc.voice.read'
      },
      {
        name: 'rpc-voice:write',
        required: false,
        value: 'rpc.voice.write'
      },
      {
        name: 'webhook-incoming',
        required: false,
        value: 'webhook.incoming'
      },
      {
        name: 'identify:premium',
        required: false,
        value: 'identify.premium'
      }
    ],
    permissionDocLink:
      'https://discord.com/developers/docs/topics/oauth2#shared-resources-oauth2-scopes',
    appIDDocLink: 'https://discord.com/developers/docs/topics/oauth2#shared-resources'
  },
  epicgames: {
    userData: [
      {
        name: 'profile',
        required: true,
        value: 'basic_profile'
      }
    ],
    permissions: [
      {
        name: 'friends',
        required: false,
        value: 'friends_list'
      },
      {
        name: 'presence:write',
        required: false,
        value: 'presence'
      },
      {
        name: 'country',
        required: false,
        value: 'country'
      }
    ],
    permissionDocLink:
      'https://dev.epicgames.com/docs/services/en-US/EpicAccountServices/GettingStarted/index.html#applicationpermissions_1',
    appIDDocLink:
      'https://dev.epicgames.com/docs/services/en-US/EpicAccountServices/GettingStarted/index.html#applicationclients_1'
  },
  facebook: {
    userData: [
      {
        name: 'profile',
        required: true,
        value: 'public_profile'
      },
      {
        name: 'email',
        required: false,
        value: 'email'
      },
      {
        name: 'age-range',
        required: false,
        value: 'user_age_range'
      },
      {
        name: 'birthday',
        required: false,
        value: 'user_birthday'
      },
      {
        name: 'gender',
        required: false,
        value: 'user_gender'
      },
      {
        name: 'hometown',
        required: false,
        value: 'user_hometown'
      },
      {
        name: 'likes',
        required: false,
        value: 'user_likes'
      },
      {
        name: 'link',
        required: false,
        value: 'user_link'
      },
      {
        name: 'location',
        required: false,
        value: 'user_location'
      },
      {
        name: 'profile-instagram',
        required: false,
        value: 'instagram_basic'
      }
    ],
    permissions: [
      {
        name: 'friends',
        required: false,
        value: 'user_friends'
      },
      {
        name: 'messenger-contact',
        required: false,
        value: 'user_messenger_contact'
      },
      {
        name: 'photos',
        required: false,
        value: 'user_photos'
      },
      {
        name: 'posts',
        required: false,
        value: 'user_posts'
      },
      {
        name: 'videos',
        required: false,
        value: 'user_videos'
      },
      {
        name: 'ads:write',
        required: false,
        value: 'ads_management'
      },
      {
        name: 'ads:read',
        required: false,
        value: 'ads_read'
      },
      {
        name: 'attribution:read',
        required: false,
        value: 'attribution_read'
      },
      {
        name: 'business:write',
        required: false,
        value: 'business_management'
      },
      {
        name: 'catalog:write',
        required: false,
        value: 'catalog_management'
      },
      {
        name: 'gaming-user_locale',
        required: false,
        value: 'gaming_user_locale'
      },
      {
        name: 'groups:read',
        required: false,
        value: 'groups_access_member_info'
      },
      {
        name: 'instagram:publish',
        required: false,
        value: 'instagram_content_publish'
      },
      {
        name: 'instagram-comments:write',
        required: false,
        value: 'instagram_manage_comments'
      },
      {
        name: 'instagram-insights:write',
        required: false,
        value: 'instagram_manage_insights'
      },
      {
        name: 'leads:read',
        required: false,
        value: 'leads_retrieval'
      },
      {
        name: 'pages-events',
        required: false,
        value: 'pages_events'
      },
      {
        name: 'ads-pages:write',
        required: false,
        value: 'pages_manage_ads'
      },
      {
        name: 'cta:write',
        required: false,
        value: 'pages_manage_cta'
      },
      {
        name: 'pages-articles:write',
        required: false,
        value: 'pages_manage_instant_articles'
      },
      {
        name: 'pages-engagement:write',
        required: false,
        value: 'pages_manage_engagement'
      },
      {
        name: 'pages-metadata:write',
        required: false,
        value: 'pages_manage_metadata'
      },
      {
        name: 'pages-posts:write',
        required: false,
        value: 'pages_manage_posts'
      },
      {
        name: 'pages-messaging',
        required: false,
        value: 'pages_messaging'
      },
      {
        name: 'pages-engagement:read',
        required: false,
        value: 'pages_read_engagement'
      },
      {
        name: 'pages-content:read',
        required: false,
        value: 'pages_read_user_content'
      },
      {
        name: 'pages-list',
        required: false,
        value: 'pages_show_list'
      },
      {
        name: 'pages-gender',
        required: false,
        value: 'pages_user_gender'
      },
      {
        name: 'pages-locale',
        required: false,
        value: 'pages_user_locale'
      },
      {
        name: 'pages-timezone',
        required: false,
        value: 'pages_user_timezone'
      },
      {
        name: 'groups:write',
        required: false,
        value: 'publish_to_groups'
      },
      {
        name: 'video:write',
        required: false,
        value: 'publish_video'
      },
      {
        name: 'insights:read',
        required: false,
        value: 'read_insights'
      },
      {
        name: 'research-apis',
        required: false,
        value: 'research_apis'
      }
    ],
    permissionDocLink: 'https://developers.facebook.com/docs/permissions/reference',
    appIDDocLink:
      'https://developers.facebook.com/docs/development/create-an-app/app-dashboard#id-----------'
  },
  github: {
    userData: [
      {
        name: 'public-profile',
        required: true,
        value: ''
      },
      {
        name: 'profile',
        required: false,
        value: 'read:user'
      },
      {
        name: 'email',
        required: false,
        value: 'user:email'
      }
    ],
    permissions: [
      {
        name: 'user',
        required: false,
        value: 'user'
      },
      {
        name: 'users-follow:write',
        required: false,
        value: 'user:follow'
      },
      {
        name: 'repo',
        required: false,
        value: 'repo'
      },
      {
        name: 'repo:status',
        required: false,
        value: 'repo:status'
      },
      {
        name: 'repo_deployment',
        required: false,
        value: 'repo_deployment'
      },
      {
        name: 'public_repo',
        required: false,
        value: 'public_repo'
      },
      {
        name: 'repo:invite',
        required: false,
        value: 'repo:invite'
      },
      {
        name: 'security_events',
        required: false,
        value: 'security_events'
      },
      {
        name: 'admin:repo_hook',
        required: false,
        value: 'admin:repo_hook'
      },
      {
        name: 'write:repo_hook',
        required: false,
        value: 'write:repo_hook'
      },
      {
        name: 'read:repo_hook',
        required: false,
        value: 'read:repo_hook'
      },
      {
        name: 'admin:org',
        required: false,
        value: 'admin:org'
      },
      {
        name: 'write:org',
        required: false,
        value: 'write:org'
      },
      {
        name: 'read:org',
        required: false,
        value: 'read:org'
      },
      {
        name: 'admin:public_key',
        required: false,
        value: 'admin:public_key'
      },
      {
        name: 'write:public_key',
        required: false,
        value: 'write:public_key'
      },
      {
        name: 'read:public_key',
        required: false,
        value: 'read:public_key'
      },
      {
        name: 'admin:org_hook',
        required: false,
        value: 'admin:org_hook'
      },
      {
        name: 'gist',
        required: false,
        value: 'gist'
      },
      {
        name: 'notifications',
        required: false,
        value: 'notifications'
      },
      {
        name: 'delete_repo',
        required: false,
        value: 'delete_repo'
      },
      {
        name: 'write:discussion',
        required: false,
        value: 'write:discussion'
      },
      {
        name: 'read:discussion',
        required: false,
        value: 'read:discussion'
      },
      {
        name: 'write:packages',
        required: false,
        value: 'write:packages'
      },
      {
        name: 'read:packages',
        required: false,
        value: 'read:packages'
      },
      {
        name: 'delete:packages',
        required: false,
        value: 'delete:packages'
      },
      {
        name: 'admin:gpg_key',
        required: false,
        value: 'admin:gpg_key'
      },
      {
        name: 'write:gpg_key',
        required: false,
        value: 'write:gpg_key'
      },
      {
        name: 'read:gpg_key',
        required: false,
        value: 'read:gpg_key'
      },
      {
        name: 'codespace',
        required: false,
        value: 'codespace'
      },
      {
        name: 'workflow',
        required: false,
        value: 'workflow'
      }
    ],
    permissionDocLink:
      'https://docs.github.com/en/developers/apps/building-oauth-apps/scopes-for-oauth-apps#available-scopes',
    appIDDocLink:
      'https://docs.github.com/en/developers/apps/managing-oauth-apps/modifying-an-oauth-app'
  },
  google: {
    userData: [
      {
        name: 'email',
        required: false,
        value: 'https://www.googleapis.com/auth/userinfo.email'
      },
      {
        name: 'profile',
        required: false,
        value: 'https://www.googleapis.com/auth/userinfo.profile'
      },
      {
        name: 'openid',
        required: false,
        value: 'openid'
      }
    ],
    permissions: [
      {
        name: 'cloud-platform',
        required: false,
        value: 'https://www.googleapis.com/auth/cloud-platform'
      },
      {
        name: 'adsense',
        required: false,
        value: 'https://www.googleapis.com/auth/adsense'
      },
      {
        name: 'analytics',
        required: false,
        value: 'https://www.googleapis.com/auth/analytics'
      },
      {
        name: 'appengine:admin',
        required: false,
        value: 'https://www.googleapis.com/auth/appengine.admin'
      },
      {
        name: 'mail:send',
        required: false,
        value: 'https://mail.google.com/'
      },
      {
        name: 'bigquery',
        required: false,
        value: 'https://www.googleapis.com/auth/bigquery'
      },
      {
        name: 'blogger',
        required: false,
        value: 'https://www.googleapis.com/auth/blogger'
      },
      {
        name: 'books',
        required: false,
        value: 'https://www.googleapis.com/auth/books'
      },
      {
        name: 'calendar:write',
        required: false,
        value: 'https://www.googleapis.com/auth/calendar'
      },
      {
        name: 'ddmconversions',
        required: false,
        value: 'https://www.googleapis.com/auth/ddmconversions'
      },
      {
        name: 'bigtable',
        required: false,
        value: 'https://www.googleapis.com/auth/bigtable.admin'
      },
      {
        name: 'content',
        required: false,
        value: 'https://www.googleapis.com/auth/content'
      },
      {
        name: 'display-video',
        required: false,
        value: 'https://www.googleapis.com/auth/display-video'
      },
      {
        name: 'doubleclickbidmanager',
        required: false,
        value: 'https://www.googleapis.com/auth/doubleclickbidmanager'
      },
      {
        name: 'files:write',
        required: false,
        value: 'https://www.googleapis.com/auth/drive'
      },
      {
        name: 'firebase',
        required: false,
        value: 'https://www.googleapis.com/auth/firebase'
      },
      {
        name: 'fitness',
        required: false,
        value: 'https://www.googleapis.com/auth/fitness.activity.write'
      },
      {
        name: 'ediscovery',
        required: false,
        value: 'https://www.googleapis.com/auth/ediscovery'
      },
      {
        name: 'classroom',
        required: false,
        value: 'https://www.googleapis.com/auth/classroom.courses'
      },
      {
        name: 'documents',
        required: false,
        value: 'https://www.googleapis.com/auth/documents'
      },
      {
        name: 'androidpublisher',
        required: false,
        value: 'https://www.googleapis.com/auth/androidpublisher'
      },
      {
        name: 'games',
        required: false,
        value: 'https://www.googleapis.com/auth/games'
      },
      {
        name: 'webmasters',
        required: false,
        value: 'https://www.googleapis.com/auth/webmasters'
      },
      {
        name: 'presentations',
        required: false,
        value: 'https://www.googleapis.com/auth/presentations'
      },
      {
        name: 'spreadsheets',
        required: false,
        value: 'https://www.googleapis.com/auth/spreadsheets'
      },
      {
        name: 'manufacturercenter',
        required: false,
        value: 'https://www.googleapis.com/auth/manufacturercenter'
      },
      {
        name: 'contacts:write',
        required: false,
        value: 'https://www.googleapis.com/auth/contacts'
      },
      {
        name: 'photoslibrary',
        required: false,
        value: 'https://www.googleapis.com/auth/photoslibrary'
      },
      {
        name: 'tagmanager',
        required: false,
        value: 'https://www.googleapis.com/auth/tagmanager.edit.containers'
      },
      {
        name: 'tasks',
        required: false,
        value: 'https://www.googleapis.com/auth/tasks'
      },
      {
        name: 'youtube',
        required: false,
        value: 'https://www.googleapis.com/auth/youtube'
      }
    ],
    permissionDocLink: 'https://developers.google.com/identity/protocols/oauth2/scopes#oauth2',
    appIDDocLink:
      'https://developers.google.com/identity/protocols/oauth2#1.-obtain-oauth-2.0-credentials-from-the-dynamic_data.setvar.console_name-.'
  },
  kakao: {
    userData: [
      {
        name: 'profile',
        required: false,
        value: 'profile'
      },
      {
        name: 'nickname',
        required: false,
        value: 'profile_nickname'
      },
      {
        name: 'image',
        required: false,
        value: 'profile_image'
      },
      {
        name: 'email',
        required: false,
        value: 'account_email'
      },
      {
        name: 'name',
        required: false,
        value: 'name'
      },
      {
        name: 'gender',
        required: false,
        value: 'gender'
      },
      {
        name: 'age-range',
        required: false,
        value: 'age_range'
      },
      {
        name: 'birthday',
        required: false,
        value: 'birthday'
      },
      {
        name: 'birthyear',
        required: false,
        value: 'birthyear'
      },
      {
        name: 'phone',
        required: false,
        value: 'phone_number'
      },
      {
        name: 'id',
        required: false,
        value: 'account_ci'
      },
      {
        name: 'address',
        required: false,
        value: 'shipping_address'
      },
      {
        name: 'link',
        required: false,
        value: 'story_permalink'
      }
    ],
    permissions: [
      {
        name: 'friends',
        required: false,
        value: 'friends'
      },
      {
        name: 'plusfriends',
        required: false,
        value: 'plusfriends'
      },
      {
        name: 'story:read',
        required: false,
        value: 'story_read'
      },
      {
        name: 'story:publish',
        required: false,
        value: 'story_publish'
      },
      {
        name: 'talk:message',
        required: false,
        value: 'talk_message'
      }
    ],
    permissionDocLink:
      'https://developers.kakao.com/docs/latest/en/kakaologin/prerequisite#consent-item',
    appIDDocLink: 'https://developers.kakao.com/docs/latest/en/getting-started/app#app-key'
  },
  linkedin: {
    userData: [
      {
        name: 'public-profile',
        required: false,
        value: 'r_basicprofile'
      },
      {
        name: 'profile',
        required: false,
        value: 'r_liteprofile'
      },
      {
        name: 'email',
        required: false,
        value: 'r_emailaddress'
      }
    ],
    permissions: [
      {
        name: 'social-user:write',
        required: false,
        value: 'w_member_social'
      },
      {
        name: 'social-org:write',
        required: false,
        value: 'w_organization_social'
      },
      {
        name: 'social-org:read',
        required: false,
        value: 'r_organization_social'
      },
      {
        name: 'ads:write',
        required: false,
        value: 'rw_ads'
      },
      {
        name: 'ads:read',
        required: false,
        value: 'r_ads'
      },
      {
        name: 'ads-report:read',
        required: false,
        value: 'r_ads_reporting'
      },
      {
        name: 'connections-1st:view',
        required: false,
        value: 'r_1st_connections_size'
      },
      {
        name: 'ads-leads:read',
        required: false,
        value: 'r_ads_leadgen_automation'
      },
      {
        name: 'audience:write',
        required: false,
        value: 'rw_dmp_segments'
      }
    ],
    permissionDocLink:
      'https://docs.microsoft.com/en-us/linkedin/shared/authentication/getting-access',
    appIDDocLink:
      'https://docs.microsoft.com/en-us/linkedin/shared/authentication/client-credentials-flow?context=linkedin/context#step-1-get-client-id-and-client-secret'
  },
  mailru: {
    userData: [
      {
        name: 'public-profile',
        required: true,
        value: 'userinfo'
      }
    ],
    permissions: [
      {
        name: 'photoslibrary',
        required: false,
        value: 'photos'
      },
      {
        name: 'guestbook',
        required: false,
        value: 'guestbook'
      },
      {
        name: 'pages-posts:write',
        required: false,
        value: 'stream'
      },
      {
        name: 'messages:write',
        required: false,
        value: 'messages'
      },
      {
        name: 'calendar:read',
        required: false,
        value: 'events'
      }
    ],
    permissionDocLink: 'https://api.mail.ru/docs/guides/restapi/#permissions',
    appIDDocLink: 'https://api.mail.ru/docs/guides/restapi/#params'
  },
  microsoft: {
    userData: [
      {
        name: 'public-profile',
        required: true,
        value: 'https://graph.microsoft.com/User.Read'
      },
      {
        name: 'other-profile',
        required: false,
        value: 'https://graph.microsoft.com/User.ReadBasic.All'
      },
      {
        name: 'profile',
        required: false,
        value: 'https://graph.microsoft.com/User.Read.All'
      }
    ],
    permissions: [
      {
        name: 'user',
        required: false,
        value: 'https://graph.microsoft.com/User.ReadWrite'
      },
      {
        name: 'users',
        required: false,
        value: 'https://graph.microsoft.com/User.ReadWrite.All'
      },
      {
        name: 'users:invite',
        required: false,
        value: 'https://graph.microsoft.com/User.Invite.All'
      },
      {
        name: 'users:export',
        required: false,
        value: 'https://graph.microsoft.com/User.Export.All'
      },
      {
        name: 'users:manage',
        required: false,
        value: 'https://graph.microsoft.com/User.ManageIdentities.All'
      },
      {
        name: 'activities:read',
        required: false,
        value: 'https://graph.microsoft.com/Analytics.Read'
      },
      {
        name: 'apps:read',
        required: false,
        value: 'https://graph.microsoft.com/AppCatalog.Read.All'
      },
      {
        name: 'apps:write',
        required: false,
        value: 'https://graph.microsoft.com/AppCatalog.ReadWrite.All'
      },
      {
        name: 'logs:read',
        required: false,
        value: 'https://graph.microsoft.com/AuditLog.Read.All'
      },
      {
        name: 'bookings:read',
        required: false,
        value: 'https://graph.microsoft.com/Bookings.Read.All'
      },
      {
        name: 'bookings:write',
        required: false,
        value: 'https://graph.microsoft.com/Bookings.Manage.All'
      },
      {
        name: 'calendar:read',
        required: false,
        value: 'https://graph.microsoft.com/Calendars.Read'
      },
      {
        name: 'calendar:write',
        required: false,
        value: 'https://graph.microsoft.com/Calendars.ReadWrite'
      },
      {
        name: 'call',
        required: false,
        value: 'https://graph.microsoft.com/Calls.Initiate.All'
      },
      {
        name: 'call-group',
        required: false,
        value: 'https://graph.microsoft.com/Calls.InitiateGroupCall.All'
      },
      {
        name: 'messages:read',
        required: false,
        value: 'https://graph.microsoft.com/Chat.Read'
      },
      {
        name: 'messages:write',
        required: false,
        value: 'https://graph.microsoft.com/Chat.ReadWrite'
      },
      {
        name: 'contacts:read',
        required: false,
        value: 'https://graph.microsoft.com/Contacts.Read'
      },
      {
        name: 'contacts:write',
        required: false,
        value: 'https://graph.microsoft.com/Contacts.ReadWrite'
      },
      {
        name: 'device:read',
        required: false,
        value: 'https://graph.microsoft.com/Device.Read'
      },
      {
        name: 'files:read',
        required: false,
        value: 'https://graph.microsoft.com/Files.Read'
      },
      {
        name: 'files:write',
        required: false,
        value: 'https://graph.microsoft.com/Files.ReadWrite'
      },
      {
        name: 'mail:read',
        required: false,
        value: 'https://graph.microsoft.com/Mail.Read'
      },
      {
        name: 'mail:write',
        required: false,
        value: 'https://graph.microsoft.com/Mail.ReadWrite'
      },
      {
        name: 'mail:send',
        required: false,
        value: 'https://graph.microsoft.com/Mail.Send'
      },
      {
        name: 'notes:read',
        required: false,
        value: 'https://graph.microsoft.com/Notes.Read'
      },
      {
        name: 'notes:write',
        required: false,
        value: 'https://graph.microsoft.com/Notes.ReadWrite'
      },
      {
        name: 'presence:read',
        required: false,
        value: 'https://graph.microsoft.com/Presence.Read'
      },
      {
        name: 'presence:write',
        required: false,
        value: 'https://graph.microsoft.com/Presence.ReadWrite'
      },
      {
        name: 'tasks:read',
        required: false,
        value: 'https://graph.microsoft.com/Tasks.Read'
      },
      {
        name: 'tasks:write',
        required: false,
        value: 'https://graph.microsoft.com/Tasks.ReadWrite'
      }
    ],
    permissionDocLink: 'https://docs.microsoft.com/en-us/graph/permissions-reference',
    appIDDocLink: 'https://docs.microsoft.com/en-us/graph/permissions-reference'
  },
  msn: {
    userData: [],
    permissions: [],
    appIDDocLink: 'https://docs.microsoft.com/en-us/graph/permissions-reference'
  },
  naver: {
    userData: [],
    permissions: [],
    appIDDocLink:
      'https://developers.naver.com/docs/common/openapiguide/appregister.md#%ED%81%B4%EB%9D%BC%EC%9D%B4%EC%96%B8%ED%8A%B8-%EC%95%84%EC%9D%B4%EB%94%94%EC%99%80-%ED%81%B4%EB%9D%BC%EC%9D%B4%EC%96%B8%ED%8A%B8-%EC%8B%9C%ED%81%AC%EB%A6%BF-%ED%99%95%EC%9D%B8'
  },
  ok: {
    userData: [
      {
        name: 'profile',
        required: true,
        value: 'VALUABLE_ACCESS'
      },
      {
        name: 'email',
        required: false,
        value: 'GET_EMAIL'
      },
      {
        name: 'long-token',
        required: false,
        value: 'LONG_ACCESS_TOKEN'
      }
    ],
    permissions: [
      {
        name: 'photos',
        required: false,
        value: 'PHOTO_CONTENT'
      },
      {
        name: 'groups',
        required: false,
        value: 'GROUP_CONTENT'
      },
      {
        name: 'videos',
        required: false,
        value: 'VIDEO_CONTENT'
      },
      {
        name: 'application:invite',
        required: false,
        value: 'APP_INVITE'
      }
    ],
    permissionDocLink: 'https://apiok.ru/ext/oauth/permissions',
    appIDDocLink: 'https://apiok.ru/dev/app/create#section-2'
  },
  wbgames: {
    userData: [],
    permissions: [],
    appIDDocLink: CONTACT_ACCOUNT_MANAGER
  },
  paypal: {
    userData: [
      {
        name: 'openid',
        required: true,
        value: 'openid'
      },
      {
        name: 'profile',
        required: false,
        value: 'profile'
      },
      {
        name: 'email',
        required: false,
        value: 'email'
      },
      {
        name: 'address',
        required: false,
        value: 'address'
      },
      {
        name: 'id',
        required: false,
        value: 'https://uri.paypal.com/services/paypalattributes'
      }
    ],
    permissions: [],
    permissionDocLink:
      'https://developer.paypal.com/docs/log-in-with-paypal/integrate/reference/#scope-attributes',
    appIDDocLink: 'https://developer.paypal.com/docs/business/get-started/#get-api-credentials'
  },
  qq: {
    userData: [
      {
        name: 'profile',
        required: false,
        value: 'get_user_info'
      }
    ],
    permissions: [],
    permissionDocLink: 'https://wiki.connect.qq.com/api%e5%88%97%e8%a1%a8',
    appIDDocLink: 'https://wiki.connect.qq.com/__trashed-2'
  },
  reddit: {
    userData: [
      {
        name: 'profile',
        required: false,
        value: 'identity'
      }
    ],
    permissions: [
      {
        name: 'user',
        required: false,
        value: 'account'
      },
      {
        name: 'credits',
        required: false,
        value: 'creddits'
      },
      {
        name: 'pages-engagement:write',
        required: false,
        value: 'edit'
      },
      {
        name: 'flair',
        required: false,
        value: 'flair'
      },
      {
        name: 'votes:read',
        required: false,
        value: 'history'
      },
      {
        name: 'live-threads:read',
        required: false,
        value: 'livemanage'
      },
      {
        name: 'modconfig',
        required: false,
        value: 'modconfig'
      },
      {
        name: 'modcontributors',
        required: false,
        value: 'modcontributors'
      },
      {
        name: 'modflair',
        required: false,
        value: 'modflair'
      },
      {
        name: 'modlog',
        required: false,
        value: 'modlog'
      },
      {
        name: 'modmail',
        required: false,
        value: 'modmail'
      },
      {
        name: 'modothers',
        required: false,
        value: 'modothers'
      },
      {
        name: 'modposts',
        required: false,
        value: 'modposts'
      },
      {
        name: 'modself',
        required: false,
        value: 'modself'
      },
      {
        name: 'modwiki',
        required: false,
        value: 'modwiki'
      },
      {
        name: 'mysubreddits',
        required: false,
        value: 'mysubreddits'
      },
      {
        name: 'messages:write',
        required: false,
        value: 'privatemessages'
      },
      {
        name: 'pages-engagement:read',
        required: false,
        value: 'read'
      },
      {
        name: 'report',
        required: false,
        value: 'report'
      },
      {
        name: 'save',
        required: false,
        value: 'save'
      },
      {
        name: 'structuredstyles',
        required: false,
        value: 'structuredstyles'
      },
      {
        name: 'submit',
        required: false,
        value: 'submit'
      },
      {
        name: 'subscribe',
        required: false,
        value: 'subscribe'
      },
      {
        name: 'vote',
        required: false,
        value: 'vote'
      },
      {
        name: 'wiki:edit',
        required: false,
        value: 'wikiedit'
      },
      {
        name: 'wiki:read',
        required: false,
        value: 'wikiread'
      }
    ],
    permissionDocLink: 'https://www.reddit.com/dev/api/oauth',
    appIDDocLink: 'https://github.com/reddit-archive/reddit/wiki/OAuth2#getting-started'
  },
  steam: {
    userData: [],
    permissions: [],
    appIDDocLink: 'https://partner.steamgames.com/doc/webapi_overview/oauth'
  },
  twitch: {
    userData: [
      {
        name: 'email',
        required: false,
        value: 'user:read:email'
      }
    ],
    permissions: [
      {
        name: 'user',
        required: false,
        value: 'user:edit'
      },
      {
        name: 'users-follow:read',
        required: false,
        value: 'user:read:follows'
      },
      {
        name: 'user-subscriptions:read',
        required: false,
        value: 'user:read:subscriptions'
      },
      {
        name: 'user-block:read',
        required: false,
        value: 'user:read:blocked_users'
      },
      {
        name: 'user-block:write',
        required: false,
        value: 'user:manage:blocked_users'
      },
      {
        name: 'analytics-extensions',
        required: false,
        value: 'analytics:read:extensions'
      },
      {
        name: 'analytics-games',
        required: false,
        value: 'analytics:read:games'
      },
      {
        name: 'bits:read',
        required: false,
        value: 'bits:read'
      },
      {
        name: 'channel:edit:commercial',
        required: false,
        value: 'channel:edit:commercial'
      },
      {
        name: 'channel:manage:broadcast',
        required: false,
        value: 'channel:manage:broadcast'
      },
      {
        name: 'channel:manage:extensions',
        required: false,
        value: 'channel:manage:extensions'
      },
      {
        name: 'channel:manage:polls',
        required: false,
        value: 'channel:manage:polls'
      },
      {
        name: 'channel:manage:predictions',
        required: false,
        value: 'channel:manage:predictions'
      },
      {
        name: 'channel:manage:redemptions',
        required: false,
        value: 'channel:manage:redemptions'
      },
      {
        name: 'channel:manage:schedule',
        required: false,
        value: 'channel:manage:schedule'
      },
      {
        name: 'channel:manage:videos',
        required: false,
        value: 'channel:manage:videos'
      },
      {
        name: 'channel:read:editors',
        required: false,
        value: 'channel:read:editors'
      },
      {
        name: 'channel:read:goals',
        required: false,
        value: 'channel:read:goals'
      },
      {
        name: 'channel:read:hype_train',
        required: false,
        value: 'channel:read:hype_train'
      },
      {
        name: 'channel:read:polls',
        required: false,
        value: 'channel:read:polls'
      },
      {
        name: 'channel:read:predictions',
        required: false,
        value: 'channel:read:predictions'
      },
      {
        name: 'channel:read:redemptions',
        required: false,
        value: 'channel:read:redemptions'
      },
      {
        name: 'channel:read:stream_key',
        required: false,
        value: 'channel:read:stream_key'
      },
      {
        name: 'channel:read:subscriptions',
        required: false,
        value: 'channel:read:subscriptions'
      },
      {
        name: 'clips:edit',
        required: false,
        value: 'clips:edit'
      },
      {
        name: 'moderation:read',
        required: false,
        value: 'moderation:read'
      },
      {
        name: 'moderator:manage:banned_users',
        required: false,
        value: 'moderator:manage:banned_users'
      },
      {
        name: 'moderator:read:blocked_terms',
        required: false,
        value: 'moderator:read:blocked_terms'
      },
      {
        name: 'moderator:manage:blocked_terms',
        required: false,
        value: 'moderator:manage:blocked_terms'
      },
      {
        name: 'moderator:manage:automod',
        required: false,
        value: 'moderator:manage:automod'
      },
      {
        name: 'moderator:read:automod_settings',
        required: false,
        value: 'moderator:read:automod_settings'
      },
      {
        name: 'moderator:manage:automod_settings',
        required: false,
        value: 'moderator:manage:automod_settings'
      },
      {
        name: 'moderator:read:chat_settings',
        required: false,
        value: 'moderator:read:chat_settings'
      },
      {
        name: 'moderator:manage:chat_settings',
        required: false,
        value: 'moderator:manage:chat_settings'
      }
    ],
    permissionDocLink: 'https://dev.twitch.tv/docs/authentication#scopes',
    appIDDocLink: 'https://dev.twitch.tv/docs/authentication#registration'
  },
  twitter: {
    userData: [],
    permissions: [],
    permissionDocLink: 'https://developer.twitter.com/en/docs/authentication/oauth-2-0',
    appIDDocLink:
      'https://developer.twitter.com/en/docs/authentication/oauth-1-0a/api-key-and-secret'
  },
  vimeo: {
    userData: [
      {
        name: 'public-profile',
        required: false,
        value: 'public'
      },
      {
        name: 'profile',
        required: false,
        value: 'private'
      }
    ],
    permissions: [
      {
        name: 'purchased:vimeo',
        required: false,
        value: 'purchased'
      },
      {
        name: 'create:vimeo',
        required: false,
        value: 'create'
      },
      {
        name: 'edit:vimeo',
        required: false,
        value: 'edit'
      },
      {
        name: 'delete:vimeo',
        required: false,
        value: 'delete'
      },
      {
        name: 'interact:vimeo',
        required: false,
        value: 'interact'
      },
      {
        name: 'upload:vimeo',
        required: false,
        value: 'upload'
      },
      {
        name: 'promo-codes:vimeo',
        required: false,
        value: 'promo_codes'
      },
      {
        name: 'files:write',
        required: false,
        value: 'video_files'
      }
    ],
    permissionDocLink: 'https://developer.vimeo.com/api/authentication',
    appIDDocLink: 'https://developer.vimeo.com/api/guides/start#register-your-app'
  },
  vk: {
    userData: [
      {
        name: 'email',
        required: false,
        value: 'email'
      }
    ],
    permissions: [
      {
        name: 'notify',
        required: false,
        value: 'notify'
      },
      {
        name: 'relationships:read',
        required: false,
        value: 'friends'
      },
      {
        name: 'photos',
        required: false,
        value: 'photos'
      },
      {
        name: 'audio',
        required: false,
        value: 'audio'
      },
      {
        name: 'videos',
        required: false,
        value: 'video'
      },
      {
        name: 'stories',
        required: false,
        value: 'stories'
      },
      {
        name: 'posts',
        required: false,
        value: 'pages'
      },
      {
        name: 'status',
        required: false,
        value: 'status'
      },
      {
        name: 'notes',
        required: false,
        value: 'notes'
      },
      {
        name: 'messages:write',
        required: false,
        value: 'messages'
      },
      {
        name: 'wall',
        required: false,
        value: 'wall'
      },
      {
        name: 'ads:write',
        required: false,
        value: 'ads'
      },
      {
        name: 'offline',
        required: false,
        value: 'offline'
      },
      {
        name: 'files',
        required: false,
        value: 'docs'
      },
      {
        name: 'groups',
        required: false,
        value: 'groups'
      },
      {
        name: 'notifications',
        required: false,
        value: 'notifications'
      },
      {
        name: 'groups:stats',
        required: false,
        value: 'stats'
      },
      {
        name: 'market',
        required: false,
        value: 'market'
      }
    ],
    permissionDocLink: 'https://vk.com/dev/permissions',
    appIDDocLink:
      'https://dev.vk.com/api/getting-started#2.%20%D0%A0%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D1%8F%20%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F'
  },
  wechat: {
    userData: [
      {
        name: 'profile',
        required: true,
        value: 'snsapi_login'
      }
    ],
    permissions: [],
    permissionDocLink:
      'https://developers.weixin.qq.com/doc/oplatform/en/Website_App/WeChat_Login/Wechat_Login.html',
    appIDDocLink:
      'https://developers.weixin.qq.com/doc/oplatform/en/Website_App/WeChat_Login/Wechat_Login.html'
  },
  weibo: {
    userData: [
      {
        name: 'email',
        required: false,
        value: 'email'
      }
    ],
    permissions: [
      {
        name: 'all',
        required: false,
        value: 'all'
      },
      {
        name: 'messages:write',
        required: false,
        value: 'direct_messages_write'
      },
      {
        name: 'messages:read',
        required: false,
        value: 'direct_messages_read'
      },
      {
        name: 'application:invite',
        required: false,
        value: 'invitation_write'
      },
      {
        name: 'groups:read',
        required: false,
        value: 'friendships_groups_read'
      },
      {
        name: 'groups:write',
        required: false,
        value: 'friendships_groups_write'
      },
      {
        name: 'status',
        required: false,
        value: 'statuses_to_me_read'
      }
    ],
    permissionDocLink: 'https://open.weibo.com/wiki/Scope',
    appIDDocLink:
      'https://open.weibo.com/wiki/%E6%8E%88%E6%9D%83%E6%9C%BA%E5%88%B6%E8%AF%B4%E6%98%8E'
  },
  xbox: {
    userData: [],
    permissions: [],
    appIDDocLink: 'https://docs.microsoft.com/en-us/graph/permissions-reference'
  },
  yahoo: {
    userData: [
      {
        name: 'profile',
        required: false,
        value: 'profile'
      },
      {
        name: 'email',
        required: false,
        value: 'email'
      }
    ],
    permissions: [
      {
        name: 'contacts:read',
        required: false,
        value: 'sdct-r'
      },
      {
        name: 'contacts:write',
        required: false,
        value: 'sdct-w'
      },
      {
        name: 'fantasy-sport:read',
        required: false,
        value: 'fspt-r'
      },
      {
        name: 'fantasy-sport:write',
        required: false,
        value: 'fspt-w'
      },
      {
        name: 'finance:read',
        required: false,
        value: 'yfin-r'
      },
      {
        name: 'finance:write',
        required: false,
        value: 'yfin-w'
      },
      {
        name: 'ads:write',
        required: false,
        value: 'admg-w'
      },
      {
        name: 'ads-publishers:read',
        required: false,
        value: 'gpub-r'
      },
      {
        name: 'messages:write',
        required: false,
        value: 'msgr-w'
      }
    ],
    permissionDocLink: 'https://developer.yahoo.com/oauth2/guide/yahoo_scopes/',
    appIDDocLink:
      'https://developer.yahoo.com/oauth2/guide/openid_connect/getting_started.html#getting-started-setup'
  },
  yandex: {
    userData: [],
    permissions: [],
    appIDDocLink: 'https://yandex.ru/dev/oauth/#start'
  },
  youtube: {
    userData: [],
    permissions: [],
    permissionDocLink: 'https://developers.google.com/identity/protocols/oauth2/scopes#oauth2',
    appIDDocLink:
      'https://developers.google.com/identity/protocols/oauth2#1.-obtain-oauth-2.0-credentials-from-the-dynamic_data.setvar.console_name-.'
  }
};

export default scopeValues;
